import type { Api } from '@cocoonspace/types/shared/api'
import type { AxiosInstance, AxiosRequestConfig } from 'axios'

import { defineEndpoint } from '../utils/define-endpoint'

export interface UpdateEvent {
	uriParams: Api.Operations['updateEvent']['parameters']['path']
	body: NonNullable<
		Api.Operations['updateEvent']['requestBody']
	>['content']['application/json']
	response: Api.Operations['updateEvent']['responses']['200']['content']['application/json']
}

export const updateEvent = (
	axiosInstance: AxiosInstance,
	overideConfig?: AxiosRequestConfig,
) =>
	defineEndpoint<UpdateEvent>(
		{
			method: 'patch',
			url: '/events/{eventId}',
			...overideConfig,
		},
		axiosInstance,
	)
